export enum LPPLevel {
    SILVER = 'Silver 100',
    SILVER_50 = 'Silver 50/50',
    GOLD = 'Gold',
    PLATINUM = 'Platinum',
    NO_LPP_UNDER_25 = 'No LPP under 25/over 65',
    NO_LPP_LESS_3_MONTH = 'No LPP less than 3 months',
    PLATINUM_PLUS = 'Platinum Plus',
    NO_LPP_LOW_SALARY = "No LPP annual salary less than CHF 22'680",
}
